<template>
  <div>
    <v-toolbar dense flat>
      <v-toolbar-title>
        <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
      </v-toolbar-title>
    </v-toolbar>

    <v-container fluid class="justify-center">
      <d-header label="New Route" />
      <create-header label="Route" :goBackTo="goback" :disabled="!canCreate" :oncreate="create" />

      <v-row>
        <v-col cols="12">
          <a-card>
            <elwrapper label="Start" midtext>
              <autocomplete-string-free-text :items="cities" :value="city_start" @input="onCityStartChanged" />
            </elwrapper>
            <elwrapper label="End" midtext>
              <autocomplete-string-free-text :items="cities" :value="city_end" @input="onCityEndChanged" />
            </elwrapper>
            <elwrapper label="Label" midtext>
              <f-text v-model="label" />
            </elwrapper>
            <elwrapper label="Distance (km)" midtext>
              <f-number v-model="distance" />
            </elwrapper>
            <elwrapper label="Travel time" midtext>
              <f-text v-model="travel_time" />
            </elwrapper>
            <RouteViasEditor v-model="vias" :cities="cities" />
            <elwrapper label="Description" midtext>
              <f-textarea v-model="description" rows="10" />
            </elwrapper>
          </a-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { RouteViasEditor, normalizeRouteVias, defaultRouteLabel, normalizeRouteCity } from "@/modules/routes";

export default {
  components: {
    RouteViasEditor,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "Database",
          to: { name: "database" },
        },
        {
          text: "Routes",
          to: { name: "database_view", params: { view: "routes", sub: "ALL" } },
        },
        {
          text: "New",
        },
      ],
      goback: { name: "database_view", params: { view: "routes", sub: "ALL" } },
      cities: [],
      active: false,
      city_start: "",
      city_end: "",
      label: "",
      distance: null,
      travel_time: "",
      vias: [],
      description: "",
    };
  },
  computed: {
    canCreate() {
      return this.city_start && this.city_end;
    },
  },
  methods: {
    syncLabelFromCities(previousStart, previousEnd, nextStart, nextEnd) {
      const currentLabel = String(this.label || "").trim();
      const previousDefault = defaultRouteLabel(previousStart, previousEnd);
      if (!currentLabel || currentLabel === previousDefault) {
        this.label = defaultRouteLabel(nextStart, nextEnd);
      }
    },
    onCityStartChanged(value) {
      const next = normalizeRouteCity(value);
      const previousStart = normalizeRouteCity(this.city_start);
      const previousEnd = normalizeRouteCity(this.city_end);
      if (previousStart === next) return;
      this.city_start = next;
      this.syncLabelFromCities(previousStart, previousEnd, next, previousEnd);
    },
    onCityEndChanged(value) {
      const next = normalizeRouteCity(value);
      const previousStart = normalizeRouteCity(this.city_start);
      const previousEnd = normalizeRouteCity(this.city_end);
      if (previousEnd === next) return;
      this.city_end = next;
      this.syncLabelFromCities(previousStart, previousEnd, previousStart, next);
    },
    create() {
      return this.$store
        .dispatch("RouteStore/addRoute", {
          city_start: this.city_start,
          city_end: this.city_end,
          label: this.label,
          distance: this.distance,
          travel_time: this.travel_time,
          vias: normalizeRouteVias(this.vias),
          description: this.description,
        })
        .then((id) => {
          this.$root.$success("Created Route: " + (this.label || defaultRouteLabel(this.city_start, this.city_end)));
          this.$router.push({
            name: "route_info",
            params: {
              id: id,
            },
          });
        })
        .catch((err) => this.$root.$error(err));
    },
    _queryCities() {
      return this.$store
        .dispatch("DatabaseStore/getCityList")
        .then((cities) => {
          this.cities = cities;
        })
        .catch((err) => this.$root.$error(err));
    },
  },
  mounted() {
    this._queryCities();
  },
};
</script>
